import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { jwtDecode } from 'jwt-decode';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RolesPermisosService {
  permisos: any[] = [];

  private readonly URL = environment.URL;

  constructor(private readonly http: HttpClient) {

    // Prueba de permisos
    const token = localStorage.getItem('token');
    if (token) {
      // Decodifica el token y extrae los permisos
      const decodedToken: any = jwtDecode(token);
      this.permisos = decodedToken.permisos || [];
    }

  }
  tieneAcceso(idRuta: number, accion: 'agregar' | 'editar' | 'eliminar'): boolean {
    const permiso = this.permisos.find(p => p.idRuta === idRuta);
    return permiso ? permiso[accion] === 1 : false; // Retorna true si tiene permiso, false si no
  }

  getPermissionsById(idRol: any): Observable<any> {
    return this.http.get(this.URL + `getPermissionsById/${idRol}`)
  }

  getNameRol(idRol: any): Observable<any> {
    return this.http.get(this.URL + `getNameRol/${idRol}`)
  }

  deletePermiso(idRol: any, idRuta: any): Observable<any> {
    return this.http.delete(this.URL + `deletePermiso/${idRol}/${idRuta}`)
  }

  updatePermisosRol(idRol: number, permisos: any[]): Observable<any> {
    const payload = { idRol, permisos };
    const url = `${this.URL}updatePermisosRol`;
    return this.http.post(url, payload);
  }

  addPermission(idRol: any, idRuta: any, idAccion: any): Observable<any> {
    return this.http.delete(this.URL + `deletePermiso/${idRol}/${idRuta}`)
  }
  removePermission(idRol: any, idRuta: any, idAccion: any): Observable<any> {
    return this.http.delete(this.URL + `deletePermiso/${idRol}/${idRuta}`)
  }
}
